// extracted by mini-css-extract-plugin
export default {"subCard":"Display_subCard__CTlCW","subHeader":"Display_subHeader__eeaAo","noSubs":"Display_noSubs__5uGe0"};